export default __webpack_public_path__ + "static/media/dreamfest (7).fb608a7b.jpg";